/**
 * @author
 * @description
 */
import axios from 'axios'
// import qs from 'qs'
// import { Notification } from 'element-ui'
import router from '../router'
axios.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => {
    return response

  },
  error => {
    return Promise.resolve(error.response)
  }
)

/**
 *
 */
function checkStatus(response) {
  if (response && response.data.code === 200) {
    return response.data.data
  } else {
    return Promise.reject(response.data)
  }
}

function checkCode(res) {
  // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
  if (res && res.response) {
    if (localStorage.getItem('exe', true)) {
      return;
    } else {
      if (res.response.data.code === 401) {
        localStorage.removeItem('Authorization')
        localStorage.removeItem('userInfo')
        router.push({
          name: 'login'
        })
      }
    }
    return Promise.reject(res.response.data)
  } else {
    return Promise.reject(res)
  }
}

let authorization = localStorage.getItem('Authorization') ? localStorage.getItem('Authorization') : ''
class Service {
  /**
   * @param
   * @return
   * */
  constructor() {
    // let Cookies = qs.parse(document.cookie, { delimiter: ';' });
    // Object.keys(Cookies).forEach((e) => {
    //     Cookies[e.trim()] = Cookies[e];
    // });
    // let csrfToken = Cookies['csrfToken'] ? Cookies['csrfToken'] : '';
    if (localStorage.getItem('ip') === '__HOST__') {
      this.$service = axios.create({
        /* global __HOST__ */
        baseURL: __HOST__.url,
        timeout: 100000,
        headers: {
          // 'x-csrf-token': csrfToken,
          Authorization: authorization
        }
      })
    } else {
      this.$service = axios.create({
        /* global __HOST__ */
        baseURL: SECOND_HOST.url,
        timeout: 100000,
        headers: {
          // 'x-csrf-token': csrfToken,
          Authorization: authorization
        }
      })
    }
  }

  initService() {
    if (localStorage.getItem('ip') === '__HOST__') {
      this.$service = axios.create({
        baseURL: __HOST__.url,
        timeout: 100000,
        headers: {
          Authorization: localStorage.getItem('Authorization')
        }
      })
    } else {
      this.$service = axios.create({
        baseURL: SECOND_HOST.url,
        timeout: 100000,
        headers: {
          Authorization: localStorage.getItem('Authorization')
        }
      })
    }
  }


  initServiceBlob() {
    if (localStorage.getItem('ip') === '__HOST__') {
      this.$service = axios.create({
        baseURL: __HOST__.url,
        timeout: 100000,
        responseType: 'blob',
        headers: {
          Authorization: localStorage.getItem('Authorization'),
        }
      })
    } else {
      this.$service = axios.create({
        baseURL: SECOND_HOST.url,
        timeout: 100000,
        responseType: 'blob',
        headers: {
          Authorization: localStorage.getItem('Authorization'),
        }
      })
    }
  }


  post(url, params) {
    if (url === '/manage-object/project/exportAttendData') {
      this.initServiceBlob()
      return this.$service
        .post(url, params)
        .then(response => {
          return response
        })
        .catch(res => {
          return checkCode(res)
        })
    } else {
      this.initService()
      return this.$service
        .post(url, params)
        .then(response => {
          return checkStatus(response)
        })
        .catch(res => {
          return checkCode(res)
        })
    }
    // return this.$service
    //   .post(url, params)
    //   .then(response => {
    //     console.log("checkStatus")
    //     console.log(response)
    //     // return checkStatus(response)
    //     return checkStatus(response)
    //   })
    //   .catch(res => {
    //     return checkCode(res)
    //   })
  }
  get(url, params) {
    this.initService()
    return this.$service
      .get(url, {
        params: params,
        data: params
      })
      .then(response => {
        return checkStatus(response)
      })
      .catch(res => {
        return checkCode(res)
      })
  }

  delete(url, params) {
    this.initService()
    return this.$service
      .delete(url, {
        params: params,
        data: params
      })
      .then(response => {
        return checkStatus(response)
      })
      .catch(res => {
        return checkCode(res)
      })
  }
  /**
   * update
   * */
  update(url, params) {
    this.initService()
    return this.$service
      .put(url, params)
      .then(response => {
        return checkStatus(response)
      })
      .catch(res => {
        return checkCode(res)
      })
  }
  /**
   * update
   * */
  put(url, params) {
    this.initService()
    return this.$service
      .put(url, params)
      .then(response => {
        return checkStatus(response)
      })
      .catch(res => {
        return checkCode(res)
      })
  }
}

export default new Service()



// WEBPACK FOOTER //
// ./src/service/service.js